export default __webpack_public_path__ + "static/media/earrings_5.b257f20b.webp";